export { default as Profile } from './Profile';
export { default as ProfileView } from './ProfileView';
export { default as ChangePasswordModal } from './ChangePasswordModal';
export { default as ChangePassword } from './ChangePassword';



// WEBPACK FOOTER //
// ./src/features/profile/index.js